module.exports = __webpack_public_path__ + "static/media/Green_Cap.c442a1c4.webp";